import { useEffect, useContext, useRef, useState } from "react";
import { ActivitiesContext } from "../../context/activities-context";

const TransparentLocationFilter = () => {
	var baseLocation = {
		id:"all",
		text:"Alle locaties"
	}
	const dropdownRef = useRef();
	const [inputValue, setInputValue] = useState("");
    const [showLocations, setShowLocations] = useState(false);
	const [filteredLocations, setFilteredLocations] = useState([]);
	const [allLocations, setAllLocations] = useState([]);
	const {
		locations,
		setLocationButtonId,
		locationButtonText,
		setLocationButtonText,
		locationQuery,
		setLocationQuery,
		distanceQuery,
		setDistanceQuery,
		setDistanceButtonId,
		dictionaryWords,
	} = useContext(ActivitiesContext);
	const label = dictionaryWords.allLocations;

	useEffect(() => {
        const checkIfClickedOutside = e => {
          if (
            showLocations &&
            dropdownRef.current &&
            !dropdownRef.current.contains(e.target)
          ) {
            setShowLocations(false)
          }
          else{
            if(inputValue.length >= 3 && dropdownRef.current.contains(e.target))
                setShowLocations(true)
          }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        
        return () => {
          document.removeEventListener("mousedown", checkIfClickedOutside)
        }
      }, [showLocations])

	  useEffect(() => {
		if(locations.length > 0){
			var newLocations = [...locations];
			newLocations.unshift(baseLocation);
			setAllLocations(newLocations)
			setFilteredLocations(newLocations);
		}
	},[locations])

	const handleInputChange = (e) => {
		if(e.target.value.length > 3){
			setShowLocations(true)
		}
		else{
			setShowLocations(false)
		}

        setInputValue(e.target.value);
		var test = filteredLocations;

		if(test.length > 0 && e.target.value != ""){
			test = test.filter(function (str) { return str.text.toLowerCase().includes(e.target.value.toLowerCase()); });
			setFilteredLocations(test);
		}
		else if(e.target.value === ""){
			setFilteredLocations(allLocations)
		}
	}

	const locationSelectionHandler = location => {
		setInputValue(location.text);
		setShowLocations(false);
		changeLocationHandler(location);
	}

	const changeLocationHandler = (location) => {
		if (location.id === "all") {
			setLocationQuery(" ");
			setDistanceQuery("");
			setLocationButtonId("all");
			setLocationButtonText("Alle locaties");
			setDistanceButtonId("");
		} else {
			setDistanceButtonId(
				`&coordinates=${location.lat},${location.lng}`
			);
			setLocationButtonId(location.id);
			setLocationButtonText(
				location.text
			);
		}
	};

	const handleClear = () => {
        setInputValue("")
        setShowLocations(false)
		setFilteredLocations(allLocations)
    }

	//c-transparent-filter c-transparent-filter__dropdown
	return (
		<div className="c-transparent-filter__input">
			<div
				ref={dropdownRef}
				className='c-input c-input--full-width'>
				<input 
					placeholder= {label}
					id="input" 
					className="c-input__field" 
					onChange={e => handleInputChange(e)}
					value={inputValue}
					autoComplete="off"    
				>        
				</input>
				{label && <label htmlFor="input" className="c-input__label">{label}</label>}
				<div className="c-input__right">
					{inputValue === ''? (
						<i className="fal fa-search"></i>
					) : (
						<i onClick={handleClear} className="fal fa-times-circle"></i>
					)}
				</div>

				{showLocations ? (
					<div className="c-input-suggestion__container">
						<ul className="c-input-suggestion__ul">
							{filteredLocations.length > 0 && filteredLocations.map( location => {
								return(
									<li 
										className="c-input-suggestion__li"
										key={location.id} 
										onClick={() => locationSelectionHandler(location)}
									>
										{location.text}
									</li>
								)
							})}
						</ul>
					</div>
				) : (
					<span></span>
				)}
			</div>
			</div>
	);
};

export default TransparentLocationFilter;
